/* cx-pdp-2026.js - Dekorlane product page refresh (2026-09-30).
   1. Add button keeps its price: Dawn resets the label to "Add" on a variant change, then publishes variantChange;
      the freshly rendered section HTML already carries "Add · $price", so its label is copied over.
   2. A dimmed backdrop behind the colour panel (cx-variant-sheet.js); a click on it closes the panel. */
(function () {
  'use strict';

  function keepPriceOnButton() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var d = event && event.data;
      if (!d || !d.html || !d.sectionId) return;
      var src = d.html.getElementById('ProductSubmitButton-' + d.sectionId);
      var dst = document.getElementById('ProductSubmitButton-' + d.sectionId);
      if (!src || !dst || dst.disabled) return;
      var srcLabel = src.querySelector('span'), dstLabel = dst.querySelector('span');
      if (srcLabel && dstLabel) dstLabel.textContent = srcLabel.textContent.trim();
    });
  }

  function backdrop() {
    if (document.querySelector('.cx-vi-backdrop')) return;
    var bd = document.createElement('div');
    bd.className = 'cx-vi-backdrop';
    bd.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bd);
    bd.addEventListener('click', function () {
      var close = document.querySelector('[data-cx-vi-sheet]:not([hidden]) [data-cx-vi-close]');
      if (close) close.click();
    });
  }

  function init() { keepPriceOnButton(); backdrop(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
